module.exports = __webpack_public_path__ + "img/album10_01.a93673b6.jpg";